import { BACKEND_API_URL } from "../environment";
import { deleteData, fetchData, postData, putData } from "./apis";

const basePath = `${BACKEND_API_URL}/ats`;

export const getDashboardStatsApi = () => {
  return fetchData(`${basePath}/dashboard`);
};

// --- Jobs ---
export const getJobsApi = (params = {}) => {
    const { id, ...query } = params;
    let url = `${basePath}/jobs`;

    if (id) {
        url += `/${id}`;
    }
    return fetchData(url, query);
};

export const createJobApi = (payload) => {
    return postData(`${basePath}/jobs`, payload);
};

export const updateJobApi = (payload) => {
    return putData(`${basePath}/jobs/${payload.id}`, payload);
};

export const disableRestoreJobApi = ({ id, action }) => {
    return postData(`${basePath}/jobs/status`, { id, action });
};

// --- Candidates ------
export const getCandidatesApi = (params = {}) => {
    const { id, ...query } = params;
    let url = `${basePath}/candidates`;

    if (id) {
        url += `/${id}`;
    }
    return fetchData(url, query);
};

export const createCandidateApi = (payload) => {
    return postData(`${basePath}/candidates`, payload);
};

export const updateCandidateApi = (payload) => {
    return putData(`${basePath}/candidates/${payload.id}`, payload);
};

export const disableRestoreCandidateApi = ({ id, action }) => {
    return postData(`${basePath}/candidates/status`, { id, action });
};

// Fetch applications for a candidate
export const getCandidateApplicationsApi = (params = {}) => {
    const { candidateId, ...query } = params;
    if (!candidateId) throw new Error("candidateId is required");

    const url = `${basePath}/candidates/${candidateId}/applications`;
    return fetchData(url, query);
};

// Get a single application by ID
export const getApplicationApi = (id) => fetchData(`${basePath}/applications/${id}`);

// Apply for a job
export const applyJobApi = (payload) => {
    return postData(`${basePath}/applications`, payload);
};

// --- Clients ---
export const getClientsApi = (params = {}) => {
    return fetchData(`${basePath}/clients`, params);
};

export const createClientApi = (payload) => {
    return postData(`${basePath}/clients`, payload);
};

export const updateClientApi = (payload) => {
    return putData(`${basePath}/clients/${payload.id}`, payload);
};

export const disableRestoreClientApi = ({ id, action }) => {
    return postData(`${basePath}/clients/status`, { id, action });
};

// --- Agencies ---
export const getAgenciesApi = (params = {}) => {
    return fetchData(`${basePath}/agencies`, params);
};

export const createAgencyApi = (payload) => {
    return postData(`${basePath}/agencies`, payload);
};

export const updateAgencyApi = (payload) => {
    return putData(`${basePath}/agencies/${payload.id}`, payload);
};

export const disableRestoreAgencyApi = ({ id, action }) => {
    return postData(`${basePath}/agencies/status`, { id, action });
};

// --- Workflows ---
export const getWorkflowsApi = (params = {}) => {
    return fetchData(`${basePath}/workflows`, params);
};

export const getWorkflowByIdApi = (id) => {
    return fetchData(`${basePath}/workflows/${id}`); 
};

export const createWorkflowApi = (payload) => {
    return postData(`${basePath}/workflows`, payload);
};

export const updateWorkflowApi = (id, payload) => {
    return putData(`${basePath}/workflows/${id}`, payload); 
};

export const deleteWorkflowApi = (id) => {
    return postData(`${basePath}/workflows/delete`, { id }); 
};

// --- Tasks --- 
export const createTaskApi = (payload) => {
    return postData(`${basePath}/tasks`, payload);
}

export const updateTaskApi = (id, payload) => {
    return putData(`${basePath}/tasks/${id}`, payload);  
};

export const deleteTaskApi = (id) => {
    return deleteData(`${basePath}/tasks/${id}`);  
};

export const updateApplicationApi = async (id, payload) => {
  return putData(`${basePath}/applications/${id}`, payload);
};

export const getWorkflowTasksApi = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = query
    ? `${basePath}/tasks/all?${query}`
    : `${basePath}/tasks/all`;

  return fetchData(url);
};

export const getWorkflowRecordsApi = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = query
    ? `${basePath}/tasks/records?${query}`
    : `${basePath}/tasks/records`;

  return fetchData(url);
};

export const approveWorkflowTaskApi = (data) => {
  return postData(`${basePath}/tasks/approve`, data);
};

export const rejectWorkflowTaskApi = (data) => {
  return postData(`${basePath}/tasks/reject`, data);
};
